import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderOptionalTextBox,
  renderAdditionalComments,
  renderFile,
  renderEffectiveDate,
  renderYesNo,
} from "./RenderUtils";

export class NameChangeRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <div>
        <Form ref={this.props.formRef}>
          <div>
            {renderEffectiveDate(request, updateRequest)}
            {renderYesNo(
              "doesInsuredHaveADBAName",
              "Does insured have a DBA name? ",
              request,
              updateRequest
            )}
            {renderOptionalTextBox(
              "newDBAName",
              "if yes, what is the DBA name?",
              request,
              updateRequest
            )}
            {renderTextBox(
              "newNameOfInsured",
              "New Name of Insured",
              request,
              updateRequest
            )}
            {renderTextBox(
              "newLegalEntity",
              "New Legal Entity",
              request,
              updateRequest
            )}
            {renderAdditionalComments(updateRequest)}
            {renderFile(request, updateRequest)}
          </div>
        </Form>
      </div>
    );
  }
}
